module.exports = __webpack_public_path__ + "img/flat-lay-business-concept.6bf6df1f.jpg";